import { ShipperGuideClient } from 'core/infra/http/ShipperGuideClient'

import { ProposalRepository } from '../infra/ProposalRepository'

export type ToggleAwardAutoSubmitFactoryDependencies = {
  repository: ProposalRepository
}

export function toggleAwardAutoSubmitFactory({
  repository,
}: ToggleAwardAutoSubmitFactoryDependencies) {
  return async function toggleAwardAutoSubmitImpl(rfpId: string, autoSubmit: boolean) {
    return repository.toggleAwardAutoSubmit(rfpId, autoSubmit)
  }
}

export function toggleAwardAutoSubmit(rfpId: string, autoSubmit: boolean) {
  const httpClient = new ShipperGuideClient()
  const repository = new ProposalRepository({ httpClient })
  const submit = toggleAwardAutoSubmitFactory({ repository })

  return submit(rfpId, autoSubmit)
}
